/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import IconCartao from 'assets/images/icon_cartao.svg';
import IconBoleto from 'assets/images/icon_boleto.svg';
import CardPayment from 'components/atoms/card_payment';
import ErrorCardModal from 'components/atoms/error_card_modal';
import TicketPayment from 'components/atoms/ticket_payment';
import ImgBandeiras from 'assets/images/bandeiras_cartao.svg';
import { useDispatch, useSelector } from 'react-redux';
import RadioButtonSelect from 'components/atoms/radio_button_select';
import { ApplicationState } from 'store';
import { CreateSaleState } from 'store/modules/create_sales_store/types';
import { createSales } from 'store/modules/create_sales_store/actions';
import { getTheLastSalePhase } from 'services/actions/get_the_last_sale_phase';
import { ProportionalSaleSimulation } from 'store/modules/proportional_sale_simulation_store/actions';
import { ProportionalSaleTypes } from 'store/modules/proportional_sale_simulation_store/types';
import { Container } from './styles';

interface SubscriptionPaymentProps {
  finalValue: number;
  baseValue: number;
  additionalValue: number;
  tradingValue: number;
  variationValue: number;
  parcel: object;
  services: Array<any>;
  plan_id: number;
  update_client_register: boolean;
  proportional: boolean;
  list_services: any;
  type_sale: string;
}

const SubscriptionPayment = (props: SubscriptionPaymentProps) => {
  const {
    finalValue,
    baseValue,
    additionalValue,
    tradingValue,
    variationValue,
    parcel,
    services,
    plan_id,
    update_client_register,
    proportional,
    list_services,
    type_sale,
  } = props;
  const PAYMENT_METHOD_CARD = 10;
  const PAYMENT_METHOD_INVOICE = 1;
  const dispatch = useDispatch();
  const [selectedPaymentCondition, setSelectedPaymentCondition] = useState<string>('1');
  const [cardHolderName, setCardHolderName] = useState<string>('');
  const [cardNumber, setCardNumber] = useState<string>('');
  const [cardExpirationMonth, setCardExpirationMonth] = useState<string>('');
  const [cardExpirationYear, setCardExpirationYear] = useState<string>('');
  const [cardCvv, setCardCvv] = useState<string>('');
  const [cardBrand, setCardBrand] = useState<string>('');
  const [salePhase, setSalePhase] = useState<number>(2);
  const [showModal, setShowModal] = useState<boolean>(true);
  const [showModalError, setShowModalError] = useState<boolean>(false);
  const [buttonSale, setButtonSale] = useState<boolean>(true);
  const [paymentType, setPaymentType] = useState('cartao');

  const typePayment = (tipoPagamento: string, updateAll = false) => {
    !updateAll && setPaymentType(tipoPagamento);
  };

  const { create_sale, requestCreate } = useSelector<ApplicationState, CreateSaleState>(
    (state) => state.session.create_sale,
  );

  const optionDescription = (installments: number, value: string) => {
    if (value[1] === String(finalValue))
      return `R$ ${parseFloat(value[1]).toFixed(2).replace('.', ',')} à vista`;
    return `Parcelado em ${value[0]}x de R$ ${parseFloat(value[1]).toFixed(2).replace('.', ',')}`;
  };

  useEffect(() => {
    (async () => {
      setSalePhase(await getTheLastSalePhase());
    })();
  }, []);

  const createSale = async () => {
    const plan = {
      valor_adicional: additionalValue,
      valor_base: baseValue,
      valor_negociacao: tradingValue,
      valor_total: finalValue,
      valor_variacao_forma_pagamento: variationValue,
      renewal: 0,
      status_id: 1,
      servicos: list_services?.map((dados: any) => {
        return {
          plano_id: plan_id,
          plano_nome: dados.nome,
          fase_servico_id: salePhase,
          servico_id: dados?.id,
          valor_base: dados.valor,
        };
      }),
      payment_condition_id: selectedPaymentCondition,
      payment_form: paymentType === 'cartao' ? PAYMENT_METHOD_CARD : PAYMENT_METHOD_INVOICE,
      credit_card_holder_name: cardHolderName,
      credit_card_number: cardNumber.replace(/\s+/g, ''),
      credit_card_expiration_month: cardExpirationMonth,
      credit_card_expiration_year: cardExpirationYear,
      credit_card_cvv: cardCvv,
      credit_card_brand: cardBrand,
      selectedPackageName: services[0]?.nome,
      proportional,
      update_client_register,
    };
    dispatch(createSales(plan));
    setShowModal(false);
  };

  useEffect(() => {
    requestCreate.loading ? setButtonSale(true) : setButtonSale(false);
  }, [requestCreate]);

  useEffect(() => {
    cardHolderName === '' ||
    cardNumber === '' ||
    cardExpirationMonth === '' ||
    cardBrand === '' ||
    cardExpirationMonth === '__' ||
    cardExpirationYear === '__' ||
    cardCvv === '' ||
    cardCvv === '__'
      ? setButtonSale(true)
      : setButtonSale(false);
  }, [cardHolderName, cardNumber, cardExpirationMonth, cardBrand, cardExpirationYear, cardCvv]);

  useEffect(() => {
    if (
      type_sale === 'proporcional' &&
      create_sale?.vigencia_inicio !== '' &&
      create_sale?.return_code === null
    ) {
      window.location.href = '/compra_realizada';
    } else if (create_sale?.return_code !== null) {
      setShowModalError(true);
      setShowModal(true);
    } else if (
      type_sale === 'register' &&
      create_sale?.vigencia_inicio !== '' &&
      create_sale?.return_code === null
    ) {
      window.location.href = '/painel';
    }
  }, [create_sale]);

  useEffect(() => {
    paymentType === 'boleto' ? setButtonSale(false) : setButtonSale(true);
    type_sale === 'proporcional' &&
      (async () => {
        dispatch(
          ProportionalSaleSimulation({
            payment_form: paymentType === 'boleto' ? 1 : 10,
            services_ids: services,
          }),
        );
      })();
    dispatch({ type: ProportionalSaleTypes.PAYMENT, payment: paymentType });
  }, [paymentType]);

  return (
    <Container>
      <div className="col-md-12 p-0">
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-md-12">
                <div className="row">
                  <div className="col-md-7">
                    <RadioButtonSelect
                      isChecked={paymentType === 'cartao'}
                      text="cartao"
                      toggleSelectContracts={typePayment}
                    />
                    <img className="px-1" src={IconCartao} alt="Icone Cartão" /> Cartão de Crédito
                  </div>
                  <div className="col-md-5">
                    <RadioButtonSelect
                      isChecked={paymentType === 'boleto'}
                      text="boleto"
                      toggleSelectContracts={typePayment}
                    />
                    <img className="px-1" src={IconBoleto} alt="Icone Cartão" /> Boleto
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                {paymentType === 'cartao' ? (
                  <CardPayment
                    cardHolderName={cardHolderName}
                    setCardHolderName={setCardHolderName}
                    cardNumber={cardNumber}
                    setCardNumber={setCardNumber}
                    cardExpirationMonth={cardExpirationMonth}
                    setCardExpirationMonth={setCardExpirationMonth}
                    cardExpirationYear={cardExpirationYear}
                    setCardExpirationYear={setCardExpirationYear}
                    cardCvv={cardCvv}
                    setCardCvv={setCardCvv}
                    cardBrand={cardBrand}
                    setCardBrand={setCardBrand}
                  />
                ) : (
                  <TicketPayment />
                )}
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Parcelas</label>
                  <select
                    className="form-control"
                    onChange={(event) => setSelectedPaymentCondition(event?.target?.value)}
                    defaultValue=""
                  >
                    {Object.entries(parcel)?.map((paymentCondition: any, idx: number) => {
                      return (
                        <option key={`payment_condition_option_${idx}`} value={idx + 1}>
                          {optionDescription(idx, paymentCondition)}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <p className="mt-2">
                  Ao confirmar a compra, você declara estar ciente e de acordo com os nossos Termos
                  de Uso, Responsabilidade Civil e Política de Privacidade
                  <a
                    href="https://conlicitacao.com.br/termos-de-uso"
                    target="blank"
                    style={{ marginLeft: '5px' }}
                  >
                    Termos de uso
                  </a>
                </p>
                <button
                  type="button"
                  className="btn btn-primary btn-lg btn-block"
                  disabled={buttonSale}
                  onClick={() => createSale()}
                >
                  Confirmar compra
                </button>
                {paymentType === 'cartao' && (
                  <div>
                    <p className="mt-2">
                      *Para sua comodidade, a assinatura será renovada automaticamente ao preço
                      atual da assinatura.
                    </p>
                    <p className="mt-2">
                      *A emissão de apólices de seguro garantia por usuários cadastrados nesta conta
                      gera obrigações autônomas junto às seguradoras e é de responsabilidade
                      exclusiva do contratante.
                    </p>
                    <img src={ImgBandeiras} alt="Bandeira cartões" className="mt-2" />
                  </div>
                )}
              </div>
            </div>
          </div>
          {showModalError && (
            <ErrorCardModal
              setShowModal={setShowModal}
              showModal={showModal}
              typeSale="create_sale"
              saleService={type_sale}
            />
          )}
        </div>
      </div>
    </Container>
  );
};
export default SubscriptionPayment;
